import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import ChallengeInfo from './ChallengeInfo'
import { getUserGoal, getUserGoals } from '../Activity/store/ActivitySelectors'
import { cancelGetChallengesWithProgress, getSingleChallengeWithProgress } from '../Activity/store/ActivityActions'
import { hasRoleInCompany } from '../../common/auth/authSelectors'
import { CompanyId, Role } from '../../services/api.types'
import { getDivisionCategories as getDivisionCategoriesSelector } from '../TeamManagement/store/TeamManagementSelectors'

const mapStateToProps = (state: IGlobalState, ownProps: any) => ({
  goalId: ownProps.match.params.goalId,
  goal: getUserGoal(state, ownProps.match.params.goalId),
  goals: getUserGoals(state),
  divisionCategories: getDivisionCategoriesSelector(state),
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
})

const mapDispatchToProps = {
  getSingleChallengeWithProgress,
  cancelGetChallengesWithProgress,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChallengeInfo)
